import { Link } from "react-router-dom";
import { Container, Row, Col, Image, Button, Form } from "react-bootstrap";
import "./Selection.css";

export default function Bselect() {
  return (
    <>
      <Container>
        <Row className="justify-content-md-center">
          <Col>
            <br />
            <br />
            <div center className="d-grid gap-2">
              <Link className="linkBtn" to="/raml">
                نقطه ریزی
              </Link>
              <Link className="linkBtn" to="/selectraml">
                انتخاب شکل
              </Link>
              <Link className="linkBtn" to="/question">
                ثبت تجربه
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
